import React from 'react'
import { Button } from 'react-bootstrap'
import "./Button.css"
import assetService from '../../Services/assetService'

const DownloadButton = ({ item }) => {
    const handleLinkClick = async (e) => {
        e.stopPropagation();
        try {
            await assetService.updateDownloadCount(item.channelGuid, [item.globalAssetId]);
        } catch (error) {
            console.error("Error updating download count: ", error);
        }
    }

    return (
        <a className="pull-right ps-3" href={item.downloadUrl} onClick={(e) => handleLinkClick(e)}>
            <Button variant="primary" size="sm" className="custom-button">
                <i className="bi bi-download"></i>
                <span>  Download</span>
            </Button>
        </a>
    )
}

export default DownloadButton